import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";


export default function MapSection({
  customClass = "",
  heading,
  mapSrc,
  mapLink,
  addressLine1,
  addressLine2,
  addressLine3,
  addressLine4,
  addressPostcode,
  cards = [],
  TransportCardBtn,
  TransportCardLink = '/',
  TransportCardBtnText,
  bottomCard,
  bottomCardText,
  bottomCardLink = 'https://www.warringtonsownbuses.co.uk/journey-planner',
  bottomCardBtnText = 'Warrington’s Own Buses',
}) {
  return (
    <section id="MapsSection" className={`${styles.root} ${customClass} mt-4`}>
      <Container>
        <h1>{heading}</h1>

        <Row className="g-0 map-container">
          <Col xl={8} sm={12}>
            <iframe
              src={mapSrc}
              width="100%"
              height="240"
              style={{ border: 0, display: "block" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Col>
          <Col xl={4} sm={12}>
            <div className="address-card">
              <div className="address-text">
                <h3>Site location</h3>
                <p className="mt-2">
                  {addressLine1 && <>{addressLine1}<br /></>}
                  {addressLine2 && <>{addressLine2}<br /></>}
                  {addressLine3 && <>{addressLine3}<br /></>}
                  {addressLine4 && <>{addressLine4}<br /></>}
                  {addressPostcode}
                </p>
              </div>
              <a
                href={mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="view-map-btn"
              >
                View on Map
              </a>
            </div>
          </Col>
        </Row>

        <Row className="mt-5 align-items-stretch">
          {cards.map((card, index) => (
            <Col xl={6} sm={12} key={index} className={index === 0 ? "d-flex flex-column" : "d-flex"}>
              <div className="top-card w-100 d-flex flex-column">
                <div className="d-flex align-items-center gap-2">
                  {card.icon && (
                    <div className="cardIcon">
                      <img width={80} src={card.icon} alt="" />
                    </div>
                  )}
                  <h4 className="mb-0">{card.heading}</h4>
                </div>
                {card.subHeading && (
                  <div className="cardSubHeading">
                    <strong>{card.subHeading}</strong>
                  </div>
                )}
                {card.bulletPoints && (
                  <div className="cardBulletPoints">
                    <ul className="list-unstyled">
                      {card.bulletPoints.map((point, i) => (
                        <li key={i}>
                          <strong>{point.label}</strong> {point.value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {(card.buslines || card.bottomText) && (
                  <div className="mt-auto">
                    {card.buslines && (
                      <div className="buslines">
                        <span>{card.buslines}</span>
                      </div>
                    )}
                    {card.bottomText && (
                      <div className="bottomText">
                        <span>{card.bottomText}</span>
                      </div>
                    )}
                  </div>
                )}
                <div className="CardBtnWrapper d-flex justify-content-end mt-auto">
                  {TransportCardBtn && (
                <Link href={TransportCardLink}>
                <a className="bottomBtn text-decoration-none mt-3" target="_blank" rel="noopener noreferrer">
                  {TransportCardBtnText}
                </a>
              </Link>
                  )}

                </div>
              </div>
              {index === 0 && bottomCard && (
                <div className="bottom-card">
                  <span>{bottomCardText}</span>
                  {bottomCardLink && (
                    <Link href={bottomCardLink}>
                      <a className="bottomBtn text-decoration-none mt-3">
                        {bottomCardBtnText}
                      </a>
                    </Link>
                  )}
                </div>
              )}
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
}